import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const blogPosts = [
  {
    id: 1,
    slug: '/blog/performance-bonds-pa-contractors',
    category: 'Surety Bonds',
    date: 'October 6, 2025',
    title: 'What Every Pennsylvania Contractor Needs to Know About Performance Bonds',
    excerpt: 'Performance bonds are a critical requirement for public and private construction projects across Bucks County and Montgomery County. Learn how they protect project owners and how to qualify.',
    readTime: '5 min read',
    image: 'https://public.readdy.ai/ai/img_res/0393a4a39a2d1b6dd9bb9e77e09bb2be.jpg',
  },
  {
    id: 2,
    slug: '/blog/general-liability-contractors-bucks-county',
    category: 'Construction Insurance',
    date: 'October 20, 2025',
    title: 'Understanding General Liability Insurance for Contractors in Bucks County',
    excerpt: "General liability coverage is the foundation of any contractor's insurance program. We break down what's covered, what's excluded, and how to make sure your Bucks County business is fully protected.",
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=professional%20contractor%20signing%20insurance%20documents%20at%20a%20desk%2C%20construction%20blueprints%20and%20hard%20hat%20nearby%2C%20clean%20office%20environment%2C%20neutral%20light%20background%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=gl002&orientation=landscape',
  },
  {
    id: 3,
    slug: '/blog/risk-management-montgomery-county',
    category: 'Risk Management',
    date: 'November 3, 2025',
    title: 'Top 5 Risk Management Strategies for Montgomery County Construction Firms',
    excerpt: 'Proactive risk management can save your construction business thousands of dollars and protect your reputation. Here are the five strategies our team recommends for contractors in Montgomery County, PA.',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=construction%20project%20manager%20reviewing%20risk%20assessment%20documents%20at%20a%20job%20site%20in%20Pennsylvania%2C%20safety%20equipment%20visible%2C%20organized%20workspace%2C%20clean%20neutral%20background%2C%20professional%20setting%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=rm003&orientation=landscape',
  },
  {
    id: 4,
    slug: '/blog/union-bonds-pa-contractors',
    category: 'Surety Bonds',
    date: 'November 17, 2025',
    title: 'How Union Bonds Work and Why They Matter for PA Contractors',
    excerpt: 'If you work with union labor in Pennsylvania, you may be required to post a union bond. We explain the process, the costs, and how The Stoll Agency makes it fast and straightforward.',
    readTime: '4 min read',
    image: 'https://readdy.ai/api/search-image?query=union%20construction%20workers%20at%20a%20Pennsylvania%20job%20site%2C%20group%20of%20tradespeople%20in%20safety%20gear%2C%20industrial%20building%20background%2C%20clean%20neutral%20sky%2C%20professional%20photorealistic%20image%2C%20high%20quality&width=600&height=400&seq=ub004&orientation=landscape',
  },
  {
    id: 5,
    slug: '/blog/workers-comp-pa-contractors',
    category: 'Construction Insurance',
    date: 'December 1, 2025',
    title: "Workers' Compensation Insurance: A Guide for Pennsylvania Contractors",
    excerpt: "Workers' comp is required by law in Pennsylvania. Understanding your obligations, how premiums are calculated, and how to manage claims can make a significant difference to your bottom line.",
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=injured%20construction%20worker%20receiving%20first%20aid%20on%20a%20Pennsylvania%20job%20site%2C%20safety%20officer%20assisting%2C%20clean%20industrial%20background%2C%20professional%20photorealistic%20image%2C%20neutral%20tones%2C%20high%20quality&width=600&height=400&seq=wc005&orientation=landscape',
  },
  {
    id: 6,
    slug: '/blog/pharmacy-insurance-pennsylvania',
    category: 'Business Insurance',
    date: 'December 15, 2025',
    title: 'Pharmacy Insurance in Pennsylvania: What Coverage Does Your Pharmacy Really Need?',
    excerpt: 'Running a pharmacy in Pennsylvania comes with unique risks that standard business policies don\'t address. From dispensing errors to robbery, here\'s the coverage every PA pharmacy needs.',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=professional%20pharmacist%20working%20behind%20a%20clean%20modern%20pharmacy%20counter%20in%20Pennsylvania%2C%20medication%20shelves%20in%20background%2C%20bright%20clinical%20environment%2C%20neutral%20white%20background%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=ph006&orientation=landscape',
  },
  {
    id: 7,
    slug: '/blog/medical-practice-insurance-pennsylvania',
    category: 'Business Insurance',
    date: 'January 5, 2026',
    title: 'Medical Practice Insurance in Pennsylvania: Protecting Your Practice from Every Angle',
    excerpt: 'Medical practices face a complex web of insurance requirements. Whether you run a solo practice or a multi-specialty group in Bucks County, here\'s what you need to know.',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=professional%20doctor%20reviewing%20insurance%20documents%20in%20a%20modern%20medical%20office%20in%20Pennsylvania%2C%20clean%20clinical%20environment%2C%20stethoscope%20on%20desk%2C%20neutral%20white%20background%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=mp007&orientation=landscape',
  },
  {
    id: 8,
    slug: '/blog/retail-business-insurance-pennsylvania',
    category: 'Business Insurance',
    date: 'January 19, 2026',
    title: 'Retail Business Insurance in Pennsylvania: A Complete Coverage Guide',
    excerpt: 'Whether you operate a boutique in Doylestown or a multi-location chain across Bucks County, your retail business faces risks that require specialized insurance protection.',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=modern%20retail%20store%20interior%20in%20Pennsylvania%20with%20clean%20shelves%20and%20products%2C%20bright%20professional%20lighting%2C%20neutral%20white%20and%20gray%20tones%2C%20no%20people%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=ri008&orientation=landscape',
  },
  {
    id: 9,
    slug: '/blog/builders-risk-insurance-pennsylvania',
    category: 'Construction Insurance',
    date: 'February 2, 2026',
    title: "Builder's Risk Insurance: What Pennsylvania Contractors Need to Know",
    excerpt: "Builder's risk insurance is one of the most important — and most misunderstood — coverages in construction. Here's everything PA contractors need to know before starting their next project.",
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=construction%20site%20with%20building%20frame%20under%20construction%20in%20Pennsylvania%2C%20steel%20beams%20and%20scaffolding%2C%20clear%20sky%20background%2C%20professional%20photorealistic%20image%2C%20neutral%20tones%2C%20high%20quality&width=600&height=400&seq=br009&orientation=landscape',
  },
  {
    id: 10,
    slug: '/blog/license-permit-bonds-pennsylvania',
    category: 'Surety Bonds',
    date: 'February 16, 2026',
    title: 'License & Permit Bonds for Pennsylvania Contractors: What You Need and Why',
    excerpt: 'License and permit bonds are a standard part of the licensing process for many trades in PA. Failing to have one can mean losing your license or being unable to pull permits.',
    readTime: '4 min read',
    image: 'https://readdy.ai/api/search-image?query=contractor%20holding%20a%20building%20permit%20and%20license%20documents%20at%20a%20Pennsylvania%20municipal%20office%2C%20professional%20setting%2C%20clean%20neutral%20background%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=lp010&orientation=landscape',
  },
  {
    id: 11,
    slug: '/blog/commercial-auto-insurance-pa-contractors',
    category: 'Construction Insurance',
    date: 'March 2, 2026',
    title: 'Commercial Auto Insurance for Pennsylvania Contractors: Protecting Your Fleet',
    excerpt: 'Your fleet is one of your biggest assets — and liabilities. Learn why personal auto insurance falls short and how to properly protect your contractor vehicles in Pennsylvania.',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=fleet%20of%20contractor%20work%20trucks%20parked%20at%20a%20Pennsylvania%20construction%20company%20yard%2C%20white%20and%20gray%20trucks%2C%20clean%20industrial%20background%2C%20daytime%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=ca011&orientation=landscape',
  },
  {
    id: 12,
    slug: '/blog/umbrella-insurance-pa-contractors',
    category: 'Construction Insurance',
    date: 'March 16, 2026',
    title: 'Why Pennsylvania Contractors Need an Umbrella Policy — And How Much Coverage Is Enough',
    excerpt: 'A single serious accident can generate a claim that exceeds your standard policy limits. Discover how a commercial umbrella policy protects Pennsylvania contractors from catastrophic losses.',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=business%20professional%20reviewing%20umbrella%20insurance%20policy%20documents%20at%20a%20desk%2C%20construction%20project%20photos%20in%20background%2C%20clean%20modern%20office%2C%20neutral%20tones%2C%20photorealistic%2C%20high%20quality&width=600&height=400&seq=ui012&orientation=landscape',
  },
];

const categories = ['All', 'Surety Bonds', 'Construction Insurance', 'Risk Management', 'Business Insurance'];

const BlogPage = () => {
  const [activeCategory, setActiveCategory] = useState('All');

  const filtered = activeCategory === 'All'
    ? blogPosts
    : blogPosts.filter((p) => p.category === activeCategory);

  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-teal-400 text-sm font-semibold tracking-widest uppercase mb-4">
            Bucks County &amp; Montgomery County PA
          </p>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">Blog &amp; Resources</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Insights on construction insurance, surety bonding, and business risk management for Pennsylvania companies
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-10 bg-slate-950 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === cat
                    ? 'bg-teal-500 text-white'
                    : 'bg-slate-800 border border-slate-700 text-slate-300 hover:border-teal-500/50 hover:text-teal-400'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filtered.map((post) => (
              <article
                key={post.id}
                className="bg-slate-800 border border-slate-700 rounded-2xl overflow-hidden hover:border-teal-500/40 hover:shadow-xl hover:shadow-teal-900/20 transition-all duration-300 hover:-translate-y-1 flex flex-col"
              >
                <div className="w-full h-48 overflow-hidden flex-shrink-0">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="px-3 py-1 bg-teal-500/10 border border-teal-500/20 text-teal-400 text-xs font-semibold rounded-full whitespace-nowrap">
                      {post.category}
                    </span>
                    <span className="text-slate-500 text-xs">{post.date}</span>
                  </div>
                  <h2 className="text-lg font-bold text-white mb-3 leading-snug">{post.title}</h2>
                  <p className="text-slate-400 text-sm leading-relaxed flex-1">{post.excerpt}</p>
                  <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-700">
                    <span className="text-xs text-slate-500 flex items-center gap-1">
                      <i className="ri-time-line text-teal-400"></i>
                      {post.readTime}
                    </span>
                    <Link
                      to={post.slug}
                      className="text-teal-400 text-sm font-semibold hover:text-teal-300 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
                    >
                      Read More <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-slate-800 border-t border-slate-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Have Questions About Your Coverage?</h2>
          <p className="text-slate-400 mb-8">
            Our team of construction insurance and surety bond specialists in{' '}
            <strong className="text-white">Bucks County</strong> and{' '}
            <strong className="text-white">Montgomery County</strong> is ready to help.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-4 bg-teal-500 text-white rounded-full font-semibold hover:bg-teal-400 transition-all whitespace-nowrap cursor-pointer"
          >
            Contact Us Today <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
